<template>
    <!-- 视频播放器-->
    <div id="ali-player"
         class="ali-player__auto"
         v-click-outside="closeVideo">
        <div class="ali-player-include">
            <div id="ali-player-container"></div>
        </div>
        <i v-if="Boolean(player)" @click="closeVideo" class="icon-close-player ali-video-close"></i>
    </div>
</template>

<script>
  import { mapState, mapActions} from 'vuex'

  export default {
    name: "ali-video-player",
    data() {
      return {
        player: null,   //视频播放器
        aliplayerSdkPath: '//g.alicdn.com/de/prismplayer/2.6.0/aliplayer-min.js',   // Aliplayer 代码的路径
      }
    },
    computed: {
      ...mapState({
        videoUrlParams: state => state.aliPlayerUrl
      })
    },
    watch: {
      videoUrlParams(newVideo) {
        if (newVideo) {
          this.showVideo(newVideo);   //初始化新的视频
        }
      }
    },
    mounted () {
      let playerScriptTag = document.getElementById('aliPlayerScriptTag')
      // 如果这个tag不存在，则生成相关代码tag以加载代码
      if (playerScriptTag === null) {
        playerScriptTag = document.createElement('script')
        playerScriptTag.type = 'text/javascript'
        playerScriptTag.src = this.aliplayerSdkPath
        playerScriptTag.id = 'aliPlayerScriptTag'
        let s = document.getElementsByTagName('head')[0]
        s.appendChild(playerScriptTag)
      }
    },
    methods: {
      ...mapActions({
        action_getVideoPlayUrl: 'action_getVideoPlayUrl'
      }),
      closeVideo() {
        if (this.player) {
          this.player = null;
          document.getElementsByClassName('ali-player-include')[0].innerHTML = '<div id="ali-player-container"></div>'
        }
      },
      initPlayer(source) {
        this.player = new Aliplayer({
          id: 'ali-player-container',
          autoplay: true,//是否自动播放
          playsinline:true,//H5是否内置播放
          useH5Prism:true,//强制H5播放器
          isLive:false,//是不是直播
          preload:true,//播放器自动加载
          snapshot:true,//falsh启用截图
          width:"755px",
          height:"395px",
          controlBarVisibility:"hover",//控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
          source: source, //这里 记住一定是JSON字符串类型 播放地址  如果有好几种格式 {'LD':556464,'HD':4564} 只有标准格式才能切换清晰度

          extraInfo:{ //定制型接口参数
            crossOrigin:"anonymous"
          },
          skinLayout:[ //按钮UI   给一部分 其余自己试
            {"name":"controlBar","align":"blabs","x":0,"y":0,
              "children":[
                {"name":"progress","align":"blabs","x":0,"y":44},
                {"name":"playButton","align":"tl","x":15,"y":12},//播放
                {"name":"fullScreenButton","align":"tr","x":10,"y":10},
                {"name":"volume","align":"tr","x":10,"y":10},//声音
                {"name":"timeDisplay","align":"tl","x":10,"y":7},
                // {"name":"snapshot","align":"tr","x":10,"y":10},//截图
                // {"name":"speedButton","align":"tr","x":10,"y":10},//倍数 {这个可以自定义 但是怎么调我一直搞不懂 会的可以帮我补充一下}
                // {"name":"streamButton","align":"tr",'x':0,'y':10},//截图
              ]},
            {"name":"fullControlBar","align":"tlabs","x":0,"y":0,
              "children":[
                {"name":"fullTitle","align":"tl","x":25,"y":6},
                {"name":"fullNormalScreenButton","align":"tr","x":24,"y":13},
                {"name":"fullTimeDisplay","align":"tr","x":10,"y":12},
                {"name":"fullZoom","align":"cc"},
              ]},
            {"name":"errorDisplay","align":"tlabs","x":0,"y":0},
            {"name":"H5Loading","align":"cc"},
            {"name":"infoDisplay","align":"cc"},//显示信息
          ]});
      },
      showVideo(params) {
        if (params.sourceUrl) {
          this.initPlayer(params.sourceUrl)
          return
        }
        this.action_getVideoPlayUrl(params).then(res => {
          if (res.erpCode === '000') {
            this.initPlayer(res.erpData.urls[0])
          } else {
            this.$message.error(res.erpMsg)
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
    @import url(//g.alicdn.com/de/prismplayer/2.6.0/skins/default/aliplayer-min.css);   //ali-player播放器css
</style>
<style>
    /*视频播放器相关css start*/
    .ali-player__auto {
        position: relative;
    }

    .prism-player .prism-info-left-bottom {
        display: none!important;
    }

    #ali-player-container.prism-player {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 9999;
    }

    .icon-close-player {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 9999;
        width: 15px;
        height: 15px;
        cursor: pointer;
        transform: translate(350px, -170px);
        background: url("../../icons/icon-close-player.svg") no-repeat;
        background-size: cover;
    }
</style>



// WEBPACK FOOTER //
// src/components/ali-video-player/index.vue